import { render, staticRenderFns } from "./winlossdetail.vue?vue&type=template&id=2fcc8fbe&scoped=true&"
import script from "./winlossdetail.vue?vue&type=script&lang=js&"
export * from "./winlossdetail.vue?vue&type=script&lang=js&"
import style0 from "./winlossdetail.vue?vue&type=style&index=0&id=2fcc8fbe&scoped=true&lang=css&"
import style1 from "./winlossdetail.vue?vue&type=style&index=1&id=2fcc8fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc8fbe",
  null
  
)

export default component.exports